import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Grow } from '@material-ui/core';

const AttachmentDetail = ({
  open,
  onClose,
  attachment,
  ...props
}) => {
  if (!open) {
    return null;
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Grow in>
        <div className='flex-columns' style={{ justifyContent: 'center', margin: 32, height: '90vh' }}>
          <img
            alt='attachment'
            src={attachment.url}
            style={{ minHeight: '100%', objectFit: 'contain' }}
            onClick={onClose}
          />
        </div>
      </Grow>
    </Modal>
  );
};

AttachmentDetail.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  attachment: PropTypes.shape({
    url: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string
  })
};

export default AttachmentDetail;
